import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, API } from "@/lib/api";

export default function AdminSubscribers() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/subscribers").then(({ data }) => {
      setSubscribers(data);
      setLoading(false);
    });
  }, []);

  const handleExport = () => {
    window.open(`${API}/admin/subscribers/export`, "_blank");
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1E3A6E] mb-2">Admin</p>
          <h1 className="font-display font-extrabold uppercase text-2xl md:text-3xl text-zinc-950 tracking-tight">Email List ({subscribers.length})</h1>
        </div>
        <Button onClick={handleExport} data-testid="admin-subscribers-export-button" className="bg-zinc-950 text-white rounded-none hover:bg-zinc-900 hover:shadow-[0px_4px_0px_0px_#4FD1C5]">
          <Download className="h-4 w-4 mr-2" /> Export CSV
        </Button>
      </div>

      {loading ? (
        <div className="flex justify-center py-14"><div className="h-8 w-8 border-2 border-zinc-300 border-t-zinc-950 rounded-full animate-spin" /></div>
      ) : (
        <div className="bg-white border border-zinc-200 rounded-sm overflow-x-auto" data-testid="admin-subscribers-table">
          <Table>
            <TableHeader>
              <TableRow className="border-zinc-200 hover:bg-transparent">
                <TableHead className="text-zinc-500">Email</TableHead>
                <TableHead className="text-zinc-500">Name</TableHead>
                <TableHead className="text-zinc-500">Sources</TableHead>
                <TableHead className="text-zinc-500">Subscribed</TableHead>
                <TableHead className="text-zinc-500">Joined</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {subscribers.map((s) => (
                <TableRow key={s.id} data-testid={`admin-subscriber-row-${s.id}`} className="border-zinc-200">
                  <TableCell className="text-zinc-950 font-medium">{s.email}</TableCell>
                  <TableCell className="text-zinc-600">{s.name || "—"}</TableCell>
                  <TableCell className="text-zinc-600">{s.sources.join(", ")}</TableCell>
                  <TableCell className={s.subscribed ? "text-[#1E3A6E]" : "text-zinc-400"}>{s.subscribed ? "Yes" : "Unsubscribed"}</TableCell>
                  <TableCell className="text-zinc-500">{new Date(s.created_at).toLocaleDateString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {subscribers.length === 0 && <p className="text-center text-zinc-500 py-10">No subscribers yet.</p>}
        </div>
      )}
    </div>
  );
}
